export default __webpack_public_path__ + "static/media/se.5656c857.svg";